<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>货源</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/bookSchedule' }"> 报号计划 </el-breadcrumb-item>
      <el-breadcrumb-item> 查看司机 </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="table-custom-box" id="auto-0">
      <el-table :data="tableData.data" border>
        <el-table-column prop="plateNumber" label="车牌号"> </el-table-column>
        <el-table-column prop="driverName" label="司机姓名" min-width="100"> </el-table-column>
        <el-table-column prop="driverMobile" label="司机手机号" min-width="100"> </el-table-column>
        <el-table-column prop="expectedTime" label="预计到场时间" min-width="140">
          <template v-slot="scope">
            <span>{{ scope.row.expectedTime | stamp2TextDateFull(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bookCreateTime" label="报号日期" min-width="140">
          <template v-slot="scope">
            <span>{{ scope.row.bookCreateTime | stamp2TextDateFull(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="agentName" label="经纪人"> </el-table-column>
        <el-table-column prop="agentMobile" label="经纪人手机号" width="100"> </el-table-column>
        <el-table-column prop="statusName" label="运单状态"> </el-table-column>
        <el-table-column prop="orderNumber" label="运单号" show-overflow-tooltip min-width="140"> </el-table-column>

        <el-table-column label="操作" width="80px">
          <template v-slot="scope">
            <el-button type="text" v-if="scope.row.canDel" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:0
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/stock.new.api.js';
export default {
  data() {
    return {
      pageSize: 20,
      tableData: {
        data: [],
        total: 0
      },
      currentPage: 1
    };
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.axiosRequest();
    },
    currentChange(val) {
      this.currentPage = val;
      this.axiosRequest();
    },
    axiosRequest() {
      axios
        .post(api.listBookDriver, {
          bookScheduleId: this.$route.params.id,
          pageSize: this.pageSize,
          pageNum: this.currentPage
        })
        .then(res => {
          this.tableData.data = res.data.data || [];
          this.tableData.total = res.data.total;
        });
    },
    handleDel(row) {
      this.$confirm('确定要删除这个司机吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          axios.post(api.companyDeleteDriverBookOrder, { id: row.id, callSource: 1 }).then(res => {
            this.$message.success('删除成功');
            this.axiosRequest();
          });
        })
        .catch(() => {});
    }
  }
};
</script>
